import { ENVIRONMENTS } from '@space-lib/constants'
import { UrlUtils } from '@space-shell/common/utils/url'
import { IS_CUSTOM_DOMAIN } from '@space-shell/constant/domain'
import { RoutesPaths } from '@space-shell/core/router'

import type { AuthServiceSettings } from './types'

const slug = UrlUtils.getSlugFromUrl(window.location.pathname)

const silentRequestTimeout = 20000

const env =
  process.env.TARGET_ENV === ENVIRONMENTS.PRODUCTION
    ? ENVIRONMENTS.PRODUCTION
    : ENVIRONMENTS.DEVELOPMENT

const clientId = IS_CUSTOM_DOMAIN
  ? process.env.AUTH_CLIENT_ID_CUSTOM_DOMAIN
  : process.env.AUTH_CLIENT_ID

export enum CAS_FLOW {
  DEFAULT = 'default',
  SURROGATE = 'surrogate'
}

export const CAS_FLOW_STORAGE_KEY = 'cas-flow'

export const CAS_JS_USER_KEY = 'cas-js:user'

const AUTH_PATH = `${window.location.origin}/en/club/${slug}`

export const DEFAULT_SETTINGS: AuthServiceSettings = {
  authority: `${process.env.SSO_URL}/oidc`,
  client_id: clientId,
  scope: 'openid profile authorities email resources user',
  silentRequestTimeout: silentRequestTimeout,
  redirect_uri: `${AUTH_PATH}${RoutesPaths.AUTH_LOGIN}`,
  silent_redirect_uri: `${AUTH_PATH}${RoutesPaths.AUTH_RENEW}`,
  post_logout_redirect_uri: `${AUTH_PATH}${RoutesPaths.AUTH_LOGOUT}`,
  extraQueryParams: { renew: true }, // Don't remove this param
  env
}
